import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import Utils from './utils/utils';

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
        accessToken: null,
		punterId: null,
		betSelection: [],
		multipleTotals: null,
		multipleSuccess: false,
        multipleError: false,
        multipleErrorMessage: '',
        multipleSubmitting: false,
        multipleAccepted: false,
		showBetSlipOddsAlert: false,
        isSubmitting: false,
		selectedOddsChange: "Don't accept odds changes"
	},
	mutations: {
        setLoggedState(state, punterData) {
			state.accessToken = punterData.token
			state.punterId = punterData.punterId
		},
		setAccessToken(state, data) {
			state.accessToken = data.token
		},
		selection(state, betSelectionObj) {
			const marketDetailId = betSelectionObj
				&& betSelectionObj.betSelection
				&& betSelectionObj.betSelection.marketDetailId;			
			const detailIndex = state.betSelection
				&& state.betSelection.findIndex(selection => selection.marketDetailId === marketDetailId);
			if (detailIndex === -1) {
				state.betSelection.push(betSelectionObj.betSelection);
			} else {
				state.betSelection.splice(detailIndex, 1);
			}									 
		},
        setSelectionSubmission(state, value) {
            const betLegIndex = state.betSelection
                && state.betSelection.findIndex(selection => selection.marketDetailId === value.data.marketDetailId);
            if (betLegIndex > -1) {
                state.betSelection[betLegIndex].success = value.data.success;
                state.betSelection[betLegIndex].errorMessage = value.data.errorMessage;
                state.betSelection[betLegIndex].error = value.data.error;
                state.betSelection[betLegIndex].betleg.submitting = value.data.submitting;
            }
        },
		setPayoutAmount(state, value) {
			const betLegIndex = state.betSelection
				&& state.betSelection.findIndex(selection => selection.marketDetailId === value.data.marketDetailId);
            if (betLegIndex > -1) {
                state.betSelection[betLegIndex].betleg.stake = value.data.stake;
                state.betSelection[betLegIndex].betleg.odds = value.data.odds;
                let payout = state.betSelection[betLegIndex].betleg.stake * state.betSelection[betLegIndex].betleg.odds;
                state.betSelection[betLegIndex].betleg.payout = Utils.roundDown(payout, 2);
			}
        },
		setMultipleSubmission(state, value) {
			state.multipleSuccess = value.data.success;
            state.multipleErrorMessage = value.data.errorMessage;
            state.multipleError = value.data.error;
            state.multipleSubmitting = value.data.submitting;
            state.multipleAccepted = value.data.accepted;
		},
		clearSelection(state, marketDetailId) {
			const detailIndex = state.betSelection
				&& state.betSelection.findIndex(selection => selection.marketDetailId === marketDetailId);
			if (detailIndex > -1) {
				state.betSelection.splice(detailIndex, 1);
			}
		},
		setShowBetSlipOddsAlert(state,value) {
			state.showBetSlipOddsAlert = value.showBetSlipOddsAlert;
		},
        setAcceptedChanges(state, value) {
            const betLegIndex = state.betSelection
                && state.betSelection.findIndex(selection => selection.marketDetailId === value.data.marketDetailId);
            if (betLegIndex > -1) {
                state.betSelection[betLegIndex].accepted = value.data.accepted;
            }
        },
		setIsSubmitting(state, value) {
			state.isSubmitting = value.isSubmitting;
		},
		setselectedOddsChange(state, value) {
			state.selectedOddsChange = value.selectedOddsChange;
		},
		removeAllBets(state) {
			state.betSelection = [];
		},
		updateBetLeg(state, betLeg) {
			const betLegIndex = state.betSelection
				&& state.betSelection.findIndex(selection => selection.marketDetailId === betLeg.marketDetailId);
			if (betLegIndex > -1) {
				state.betSelection[betLegIndex].stake = betLeg.stake;
			}
		},
		updateMultipleTotals(state, multipleTotals) {
			state.multipleTotals = multipleTotals;
		}
	},
	actions: {
        login({ commit }, data) {
			return new Promise((resolve) => {
                Axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.authToken
				Axios.get('/api/syxbetgames/punter/validate')
                    .then(res => {
					commit('setLoggedState', {
						token: res.data.responseObject.accessToken.token,
						punterId: res.data.responseObject.punterId
					})
					resolve();
				})
				.catch(error => {
					console.log(error);
					resolve();
				})
			})
		},
		addBet({ commit }, data) {
			commit('selection', {
				betSelection: data
			})
		},
		updateBetLeg({ commit }, data) {
			commit('updateSelection', {
				betSelection: data
			})
		},
		updateMultipleTotals({ commit }, totals) {
			commit('updateMultipleTotals', {
				multipleTotals: totals
			})
		},
		setShowBetSlipOddsAlert({ commit }, data) {
			commit('setShowBetSlipOddsAlert', {
				showBetSlipOddsAlert: data
			})
		},
        setAcceptedChanges({ commit }, data) {
            commit('setAcceptedChanges', {
                data: data
			})
		},
		setIsSubmitting({ commit }, data) {
			commit('setIsSubmitting', {
				isSubmitting: data
			})
		},
		setSelectionSubmission({ commit }, data) {
			commit('setSelectionSubmission', {
				data: data
			})
		},
		setPayoutAmount({ commit }, data) {
            commit('setPayoutAmount', {
				data: data
			})
		},
		setMultipleSubmission({ commit }, data) {
			commit('setMultipleSubmission', {
				data: data
			})
		},
		setselectedOddsChange({ commit }, data) {
			commit('setselectedOddsChange', {
				selectedOddsChange: data
			})
		},
		removeBet({ commit }, data) {
			commit('clearSelection', data);
		},
		removeAllBets({ commit }) {
			commit('removeAllBets');
		},
		storeCookieAccessToken({ commit }) {
			return new Promise((resolve) => {
                let myCookie = Utils.getCookie('LIP_ID');
                if (myCookie.length > 1) {
                    let myToken = JSON.parse(myCookie);
                    if (myToken !== "") {
                        commit('setAccessToken', {
                            token: myToken.accessToken.token,
                        });
                    }
                }
                else {
                    commit('setAccessToken', {
                        token: null
                    });
                }
				resolve();
			})
		}
	},
	getters: {
		punterId(state) {
			return state.punterId
		},
        accessToken(state) {
			return state.accessToken
		},
		showBetSlipOddsAlert(state) {
			return state.showBetSlipOddsAlert
		},
		isSubmitting(state) {
			return state.isSubmitting;
		},
		selectedOddsChange(state) {
			return state.selectedOddsChange
		},
		isAutheticated(state) {
			return state.accessToken !== null;
		},
		betSelection(state) {
			if (state.betSelection)
				return state.betSelection;
		},
		betSelectionCount(state) {
			if (state.betSelection)
				return state.betSelection.length;
			else
				return 0;
        },
        oddChange: (state) => (marketDetailId) => {
            const betLegIndex = state.betSelection.findIndex(betSelect => betSelect.marketDetailId === marketDetailId);
            if (betLegIndex > -1) {
                return state.betSelection[betLegIndex].betleg.odds;
            }
        },
        marketStatusIdChange: (state) => (marketDetailId) => {
            const betLegIndex = state.betSelection.findIndex(betSelect => betSelect.marketDetailId === marketDetailId);
            if (betLegIndex > -1) {
                return state.betSelection[betLegIndex].marketStatusId;
            }
        },
        marketDetailStatusChange: (state) => (marketDetailId) => {
            const betLegIndex = state.betSelection.findIndex(betSelect => betSelect.marketDetailId === marketDetailId);
            if (betLegIndex > -1) {
                return state.betSelection[betLegIndex].marketDetailStatus;
            }
        },
		payoutAmount: (state) => (marketDetailId) => {
            if (state.betSelection) {
                const betLegIndex = state.betSelection.findIndex(betSelect => betSelect.marketDetailId === marketDetailId);
                if (betLegIndex > -1) {
                    if (state.betSelection[betLegIndex].betleg.payout > 0) {
                        return state.betSelection[betLegIndex].betleg.payout;
                    }
                    else {
                        return null;
                    }
                }
            }
		},
		marketDetailIsInBetSlip: (state) => (marketDetailId) => {
			const betSelection = state.betSelection;
			const detailIndex = betSelection
				&& betSelection.findIndex(selection => selection.marketDetailId === marketDetailId);
			return detailIndex > -1;
		},
		hasRelatedEvents(state) {
			let eventIds = [];
			let betSelections = state && state.betSelection;
			let l = betSelections.length;
			if (state != null) {
				for (let i = 0; i < l; i++) {
					eventIds.push(betSelections[i] && betSelections[i].betleg.eventId);
				}
				let duplicates = eventIds.reduce(function (acc, el, i, arr) {
					if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
				}, []);
				return duplicates.length > 0 ? true : false;
			}   
		},
		getMultipleTotals(state) {
			if (state.multipleTotals)
				return state.multipleTotals;
		},
        getAcceptedChanges: (state) => (marketDetailId) => {
            const betLegIndex = state.betSelection.findIndex(betSelect => betSelect.marketDetailId === marketDetailId);
            if (betLegIndex > -1) {
                return state.betSelection[betLegIndex].accepted;
            }
		},
		getMultipleSuccess(state) {
			return state.multipleSuccess;
        },
        getMultipleSubmitting(state) {
            return state.multipleSubmitting;
        },
		getMultipleErrorMessage(state) {
			return state.multipleErrorMessage;
        },
        getMultipleError(state) {
            return state.multipleError;
        },
        getMultipleAccepted(state) {
            return state.multipleAccepted;
        }
	}
})
